import React from 'react';
import styled from 'styled-components';
import Type from './typewriter';

function Loader() {
  return (
   <div>
     <div className="wrapper">
      <svg 
      className='rail'
      viewBox='0 0 200 200'
      xmlns="http://www.w3.org/2000/svg"  
      >
        <circle cx="100" cy="100" r="80" />
    
      </svg>
      <svg
       className='bar'
       viewBox='0 0 200 200'
       xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="100" cy="100" r="80" />
      </svg>
    </div>
    <Load></Load>
    <Type />
   </div>
  )
}

const Load = styled.div`
padding: 2rem;
`

export default Loader;